module.exports = __webpack_public_path__ + "img/product_category_preview_image.0eb2b94.jpg";